import { connect } from 'react-redux';
import { denormalize } from 'normalizr';

import { schema } from '../../../../../state/schema';
import { loadCareGuide } from '../../../../../state/modules/careGuides/actions';
import { uiSetRoutingPreventTransition } from '../../../../../state/ui/actions';
import {
  careGuideSetActive,
  careGuideSetAccess,
} from '../../../../../state/modules/careGuides/actions';
import CareGuideDetailScreen from '../components/CareGuideDetailScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state, ownProps) => {
  //const id = ownProps.match.params.id
  const activeId = state.careGuides.get('activeId') ?? ownProps.match.params.id;

  const careGuide = activeId
    ? denormalize(
        state.entities.getIn(['careGuides', activeId]),
        schema.careGuide,
        state.entities.toJS()
      )
    : null;

  return {
    partnershipId: storage.get(findStorageType(), 'partnershipId'),

    isLoading: state.careGuides.get('isLoading'),
    isRoutingTransitionPrevented: state.ui.get('isRoutingTransitionPrevented'),
    careGuideId: activeId,
    careGuide: careGuide,
    isCareGuideLoading: careGuide === undefined ? true : false,
    isCareGuideActive:
      careGuide && careGuide.account && careGuide.account.is_subscription_valid,
    careGuideParnetshipStatus:
      careGuide && careGuide.partnership && careGuide.partnership.status,
    accessCareGuide: state.careGuides.get('accessCareGuide'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (id, cb) => {
      dispatch(loadCareGuide(id, cb));
    },
    preventRoutingTransition: (prevent) => {
      dispatch(uiSetRoutingPreventTransition(prevent));
    },
    setActive: (id) => {
      dispatch(careGuideSetActive(id));
    },
    setActiveAccess: (data) => {
      dispatch(careGuideSetAccess(data));
    },
  };
};

const CareGuideDetailScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CareGuideDetailScreen);

export default CareGuideDetailScreenContainer;
